import { CardLayout } from "../../components/CardLayout";
import { SectionTitle } from "../../components/SectionTitle";
import { TablePlot } from "../../components/TablePlots";

export default function DemoDataSection({ data }: { data: any }) {
  return (
    <div>
      <SectionTitle title="DATA VALIDATION" />
      <div className="grid grid-cols-3 gap-4">
        <div>
          <CardLayout
            fullHeight={true}
            title="Protocol Deviations | Participant"
            subtitle="Protocol Deviations by Status and Severity"
          >
            <div className="p-3 h-full">
              <TablePlot
                data={[data.pdParticipant]}
                mode="counts"
                categoriesTitle="Status"
                sorted={true}
              />
            </div>
          </CardLayout>
        </div>
        <div>
          <CardLayout
            fullHeight={true}
            title="Protocol Deviations | Sites"
            subtitle="Protocol Deviations by Status and Severity"
          >
            <div className="p-3 h-full">
              <TablePlot
                data={[data.pdSites]}
                mode="counts"
                categoriesTitle="Status"
                sorted={true}
              />
            </div>
          </CardLayout>
        </div>
        <div>
          <CardLayout
            fullHeight={true}
            title="Data Discrepancies by Type and Status"
            subtitle="Resolution Status of Data Discrepancies"
          >
            <div className="p-3 h-full">
              <TablePlot
                data={[data.discrepancies]}
                mode="counts"
                categoriesTitle="Status"
                sorted={true}
              />
            </div>
          </CardLayout>
        </div>
      </div>
    </div>
  );
}
